export default class PropertyCategory {
    constructor(
        public id = '',
        public name = '',
        public description = '',
    ) {}
}